<template>
      <div class="TheDetail">
        <div class="title">
          <el-form label-width="100px">
              <el-col :span="5">
                <el-form-item label="选择子公司" v-show="disabled1">
                <el-select v-model="form.subsidiary" placeholder="请选择" @change="sleList1">
                  <el-option
                    v-for="item in selList1"
                    :key="item.value"
                    :label="item.companyName"
                    :value="item">
                  </el-option>
                </el-select>
                </el-form-item>
                </el-col>

                <el-col :span="5">
                <el-form-item label="选择分部门" v-show="disabled2">
                <el-select v-model="form.department" placeholder="请选择" @change="sleList2">
                  <el-option
                    v-for="item in selList2"
                    :key="item.value"
                    :label="item.departmentName"
                    :value="item">
                  </el-option>
                </el-select>
                </el-form-item>
                </el-col>

                <el-col :span="5">
                <el-form-item label="选择组" v-show="disabled3">
                <el-select v-model="form.group" placeholder="请选择" @change="sleList3">
                  <el-option
                    v-for="item in selList3"
                    :key="item.value"
                    :label="item.groupName"
                    :value="item">
                  </el-option>
                </el-select>
                </el-form-item>
                </el-col>
                
                <el-col :span="5">
                <el-form-item label="选择员工" v-show="disabled4">
                <el-select v-model="form.employees" placeholder="请选择" @change="sleList4">
                  <el-option
                    v-for="item in selList4"
                    :key="item.value"
                    :label="item.roleUserName"
                    :value="item">
                  </el-option>
                </el-select>
                </el-form-item>
                </el-col>


            </el-form>
        </div>
        <div class="title">
            <el-form label-width="100px">
                <el-col :span="5">
                <el-form-item label="开始日期" prop="startString">
                    <el-date-picker
                        @change="TimeStart"
                        v-model="form.startTime"
                        align="right"
                        type="date"
                        placeholder="选择开始日期"
                        format="yyyy-MM-dd HH:mm:ss"
                    ></el-date-picker>
                </el-form-item>
            </el-col>
            <el-col :span="5">
                <el-form-item label="结束日期" prop="startString">
                    <el-date-picker
                        @change="TimeEnd"
                        v-model="form.endTime"
                        align="right"
                        type="date"
                        placeholder="选择结束日期"
                        format="yyyy-MM-dd HH:mm:ss"
                    ></el-date-picker>
                </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label-width="50">
                <el-button type="primary" @click="Search2">搜索</el-button>
                <el-button type="primary" @click="Reset">重置</el-button>
              </el-form-item>
            </el-col>
            </el-form>
        </div>
        <el-divider></el-divider>
        <div class="title" style="color:#606266;">
          下方列表中的数据均为父体/变体的数量，后面的国家为对应国家上传的父体/变体数量
        </div>
        <div class="title">
            <el-table :data="this.tableData" border style="width: 100%" v-loading="loading">
              <el-table-column prop="roleUserName" label="操作员" align="center"></el-table-column>
              <el-table-column prop="timePeriod" label="日期" width="99" align="center"></el-table-column>
              <el-table-column prop="insertProductDetails" label="新建" align="center"></el-table-column>
              <el-table-column prop="claimProductDetails" label="认领" align="center"></el-table-column>
              <el-table-column prop="copyProductDetails" label="复制" align="center"></el-table-column>
              <el-table-column prop="incubationProductDetails" label="孵化" align="center"></el-table-column>
              <el-table-column prop="usProductDetails" label="美国" align="center"></el-table-column>
              <el-table-column prop="caProductDetails" label="加拿大" align="center"></el-table-column>
              <el-table-column prop="mxProductDetails" label="墨西哥" align="center"></el-table-column>
              <el-table-column prop="gbProductDetails" label="英国" align="center"></el-table-column>
              <el-table-column prop="deProductDetails" label="德国" align="center"></el-table-column>
              <el-table-column prop="frProductDetails" label="法国" align="center"></el-table-column>
              <el-table-column prop="itProductDetails" label="意大利" align="center"></el-table-column>
              <el-table-column prop="esProductDetails" label="西班牙" align="center"></el-table-column>
              <el-table-column prop="nlProductDetails" label="荷兰" align="center"></el-table-column>
              <el-table-column prop="jpProductDetails" label="日本" align="center"></el-table-column>
              <el-table-column prop="auProductDetails" label="澳大利亚" align="center"></el-table-column>
              <el-table-column prop="aeProductDetails" label="阿联酋" align="center"></el-table-column>
              <el-table-column prop="sgProductDetails" label="新加坡" align="center"></el-table-column>
              <el-table-column prop="inProductDetails" label="印度" align="center"></el-table-column>
              <el-table-column prop="brProductDetails" label="巴西" align="center"></el-table-column>
            </el-table>
        </div>
        <div class="page">
                <el-pagination
                    style="margin-right:200px;"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[50, 100, 200, 400]"
                    :page-size="pagesize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                ></el-pagination>
            </div>
      </div>
</template>

<script>
import { ajaxPost, Baseurl } from "../../../api/api/api";
export default {
    data() {
      return {
        currentPage: 1,
        pagesize: 50,
        size: 50,
        total: 0,
        options:[],
        value:"",
        tableData:[],
        role:"",
        selList1:"",
        selList2:"",
        selList3:"",
        selList4:"",
        form:{
          subsidiary:"",
          department:"",
          group:"",
          employees:"",
          startTime:"",
          endTime:""
        },
        disabled1:"",
        disabled2:"",
        disabled3:"",
        disabled4:"",
        loading: ""
      };
    },
    created(){
      this.role = JSON.parse(window.localStorage.getItem("role"));
      this.Search()
      var obj = {
        rid:this.role.rid,
        system:this.role.system,
        companyId:this.role.company_id
      }
      ajaxPost(Baseurl + "roleController/selectNextInfoByRid",obj).then(res => {
            console.log(res.data)
            if(this.role.type ===2&&this.role.system==1){
              this.disabled1 = true
              this.disabled2 = true
              this.disabled3 = true
              this.disabled4 = true
              this.selList1 = res.data.data.next;
            }else if(this.role.type ===3){
              if(this.role.system == 1||this.role.system == 2){
                this.disabled1 = false
                this.disabled2 = true
                this.disabled3 = true
                this.disabled4 = true
                this.selList2 = res.data.data.next;
              }else if(this.role.system == 3){
                this.disabled1 = false
                this.disabled2 = false
                this.disabled3 = true
                this.disabled4 = true
                this.selList3 = res.data.data.next;
              }else if(this.role.system == 4){
                this.disabled1 = false
                this.disabled2 = false
                this.disabled3 = false
                this.disabled4 = true
                this.selList4 = res.data.data.next;
              }else if(this.role.system == 5&&this.role.departmentName=="财务部"||this.role.system == 5&&this.role.departmentName=="人事部"){
                this.disabled1 = false
                this.disabled2 = true
                this.disabled3 = true
                this.disabled4 = true
                this.selList2 = res.data.data.next;
              }
            }else if(this.role.system == 5&&this.role.departmentName=="客服部"){
                this.disabled1 = true
                this.disabled2 = true
                this.disabled3 = true
                this.disabled4 = true
                this.selList1 = res.data.data.next;
            }
      });
    },
    methods: {
      sleList1(val){
        // console.log(val)
        var obj = {
          rid:val.rid,
          system:val.system,
          companyId:val.company_id
        }
        ajaxPost(Baseurl + "roleController/selectNextInfoByRid",obj).then(res => {
          this.selList2 = res.data.data.next;
        })
        this.form.department = ""
        this.form.group = ""
        this.form.employees = ""
      },
      sleList2(val){
        // console.log(val)
        var obj = {
          rid:val.rid,
          system:val.system,
          companyId:val.company_id
        }
        ajaxPost(Baseurl + "roleController/selectNextInfoByRid",obj).then(res => {
          this.selList3 = res.data.data.next;
        })
        this.form.group = ""
        this.form.employees = ""
      },
      sleList3(val){
        // console.log(val)
        var obj = {
          rid:val.rid,
          system:val.system,
          companyId:val.company_id
        }
        ajaxPost(Baseurl + "roleController/selectNextInfoByRid",obj).then(res => {
          this.selList4 = res.data.data.next;
        })
        this.form.employees = ""
      },
      sleList4(val){
        console.log(val)
      },
      TimeStart(val){
        var d = new Date(val);
            var datetime =
                d.getFullYear() +
                "-" +
                (d.getMonth() + 1) +
                "-" +
                d.getDate() +
                " 00:00:00";
            this.form.startTime = datetime;
      },
      TimeEnd(val){
        var d = new Date(val);
            var datetime =
                d.getFullYear() +
                "-" +
                (d.getMonth() + 1) +
                "-" +
                d.getDate() +
                " 23:59:59";
            this.form.endTime = datetime;
      },
      Search2(){
        this.currentPage = 1
        this.Search()
      },
      Search(){
        this.loading = true
        var obj = {
          signRid:this.role.rid,
          company_id:this.form.subsidiary.company_id,
          did:this.form.department.did,
          gid:this.form.group.gid,
          rid:this.form.employees.rid,
          startTime1:this.form.startTime,
          endTime1:this.form.endTime,
          page:this.currentPage,
          size:this.size
        }
        ajaxPost(Baseurl + "productController/selectProductDetails",obj).then(res => {
          if(res.data.code == 200){
              this.tableData = res.data.data.list
              this.total = res.data.data.total;
              this.loading = false
          }
        })
      },
      Reset(){
        this.loading = true
        this.currentPage = 1
        this.form.subsidiary = ""
        this.form.department = ""
        this.form.group = ""
        this.form.employees = ""
        this.form.startTime = ""
        this.form.endTime = ""
        this.Search()
      },
      handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
            this.size = val;
            var obj = {
                signRid:this.role.rid,
                company_id:this.form.subsidiary.company_id,
                did:this.form.department.did,
                gid:this.form.group.gid,
                rid:this.form.employees.rid,
                startTime1:this.form.startTime,
                endTime1:this.form.endTime,
                page: this.currentPage,
                size: this.size
            };
            ajaxPost(Baseurl + "productController/selectProductDetails",obj).then(res => {
              this.tableData = res.data.data.list
              this.total = res.data.data.total;
            })
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.currentPage = val;
            var obj = {
                signRid:this.role.rid,
                company_id:this.form.subsidiary.company_id,
                did:this.form.department.did,
                gid:this.form.group.gid,
                rid:this.form.employees.rid,
                startTime1:this.form.startTime,
                endTime1:this.form.endTime,
                page: this.currentPage,
                size: this.size
            };
            ajaxPost(Baseurl + "productController/selectProductDetails",obj).then(res => {
              this.tableData = res.data.data.list
              this.total = res.data.data.total;
            })
        }
    }
}
</script>
<style lang="scss" scoped>
/deep/ {
    .title .el-form-item{
     margin-bottom: 0px;
  }
}
</style>
<style lang="scss" scoped>
.TheDetail{
  width: 100%;
  margin-bottom: 50px;
  /* #606266 */
}
.title{
  width: 100%;
  margin-top:20px;
}
.page {
  position: fixed;
  width: 100%;
  bottom: 0;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
}
</style>